import { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { rememberUser } from "../hooks/useUserState";

const API = process.env.REACT_APP_BACKEND_URL;

const COLOR = {
  bg: "#FAF7F0",
  ink: "#2A1E5C",
  ink2: "#5D5A6B",
  gold: "#F5CB5C",
};

export default function AuthVerifyPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [failed, setFailed] = useState(false);
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const token = params.get("token");
    if (!token) {
      setFailed(true);
      return;
    }
    (async () => {
      try {
        const res = await fetch(`${API}/api/auth/verify`, {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ token }),
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok) {
          setFailed(true);
          return;
        }
        rememberUser(data.email);
        toast.success("You're signed in 🏁");
        navigate(data.next && data.next.startsWith("/") ? data.next : "/", { replace: true });
      } catch {
        setFailed(true);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center px-6" style={{ background: COLOR.bg }}>
      <div className="max-w-md w-full text-center" data-testid="auth-verify-status">
        {failed ? (
          <>
            <h1 className="text-3xl mb-3" style={{ fontFamily: "'Fraunces', Georgia, serif", color: COLOR.ink }}>
              That link has expired
            </h1>
            <p className="text-sm leading-relaxed mb-8" style={{ color: COLOR.ink2 }}>
              Sign-in links work once and last an hour. No worries, grab a fresh one, it takes a second.
            </p>
            <Link
              to="/login"
              className="inline-block px-8 py-3.5 rounded-full font-bold text-base transition-transform hover:scale-105"
              style={{ background: COLOR.gold, color: COLOR.ink }}
              data-testid="auth-verify-retry"
            >
              Send me a new link
            </Link>
          </>
        ) : (
          <>
            <h1 className="text-3xl mb-3" style={{ fontFamily: "'Fraunces', Georgia, serif", color: COLOR.ink }}>
              Signing you in…
            </h1>
            <p className="text-sm" style={{ color: COLOR.ink2 }}>One second while we check your link.</p>
          </>
        )}
      </div>
    </div>
  );
}
